import React from 'react';

const FounderNote = () => {
  return (
    <section
      data-testid="founder-note"
      className="bg-[#f5f3ef] py-14 sm:py-20"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5 sm:gap-7">
          <img
            src="/images/founder-aditya.jpeg"
            alt="Aditya Kohli, Founder of Verilock"
            className="w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover shrink-0 grayscale"
            loading="lazy"
          />
          <div className="text-center sm:text-left">
            <p
              className="text-base sm:text-lg lg:text-xl italic leading-relaxed text-[#1a1a1a]/85 mb-4"
              style={{ fontFamily: 'Instrument Serif, serif' }}
            >
              &ldquo;I spent 5 years in B2B SaaS watching early-stage founders lose deals
              because they couldn&rsquo;t answer basic compliance questions.
              I built Verilock to fix that. In hours, not months.&rdquo;
            </p>
            <p className="text-sm font-semibold text-[#1a1a1a]">Aditya Kohli</p>
            <p className="text-xs text-[#1a1a1a]/55 mt-0.5">Founder, Verilock</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderNote;
